import { useState, useEffect } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import EstimationModal from "../components/EstimationModal";
import RendezVousModal from "../components/RendezVousModal";


const images = [
  "/image/images5.webp",
  "/image/images6.webp",
  "/image/images7.webp",
  "/image/images8.webp",
  "/image/images9.webp",
  "/image/images10.webp",
];

const ServicesCarrosserie = ({ language }: { language: string }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRdvModalOpen, setIsRdvModalOpen] = useState(false);


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const services = [
    {
      title: language === "fr" ? "Peinture Automobile" : "Car Painting",
      description:
        language === "fr"
          ? "Peinture complète, retouches, réparation d'éraflures."
          : "Full paint jobs, touch-ups, scratch repair.",
    },
    {
      title: language === "fr" ? "Réparation Carrosserie" : "Body Repair",
      description:
        language === "fr"
          ? "Réparation de bosses, redressement de châssis."
          : "Dent repair, frame straightening.",
    },
    {
      title: language === "fr" ? "Protection & Traitement" : "Protection & Coating",
      description:
        language === "fr"
          ? "Traitement antirouille, protection céramique."
          : "Rustproofing, ceramic coating.",
    },
    {
      title: language === "fr" ? "Remplacement de Vitres" : "Glass Replacement",
      description:
        language === "fr"
          ? "Remplacement de pare-brise, vitres latérales et lunette arrière."
          : "Windshield, side window, and rear window replacement.",
    },
    {
      title: language === "fr" ? "Débosselage sans peinture" : "Paintless Dent Removal",
      description:
        language === "fr"
          ? "Élimination des bosses sans endommager la peinture d'origine."
          : "Removing dents without damaging the original paint.",
    },
    {
      title: language === "fr" ? "Réparation de Pare-Chocs" : "Bumper Repair",
      description:
        language === "fr"
          ? "Réparation ou remplacement de pare-chocs endommagés."
          : "Repair or replacement of damaged bumpers.",
    },
    {
      title: language === "fr" ? "Estimation de Dommages" : "Damage Assessment",
      description:
        language === "fr"
          ? "Évaluation complète des dommages pour assurance ou réparation."
          : "Complete damage assessment for insurance or repair.",
    },
    {
      title: language === "fr" ? "Polissage et Lustrage" : "Polishing & Buffing",
      description:
        language === "fr"
          ? "Suppression des micro-rayures et ravivage de la brillance."
          : "Scratch removal and shine restoration.",
    },
    {
      title: language === "fr" ? "Remise à neuf des Phares" : "Headlight Restoration",
      description:
        language === "fr"
          ? "Nettoyage, polissage et protection des phares ternis."
          : "Cleaning, polishing, and sealing foggy headlights.",
    },
    {
      title: language === "fr" ? "Remplacement de Pièces de Carrosserie" : "Body Parts Replacement",
      description:
        language === "fr"
          ? "Remplacement des ailes, capots, portières, etc."
          : "Replacement of fenders, hoods, doors, and more.",
    },
    {
      title: language === "fr" ? "Réparation d'Arêtes et Coins" : "Edge & Corner Repair",
      description:
        language === "fr"
          ? "Réparation précise des arêtes et coins endommagés."
          : "Precise repair of damaged vehicle edges and corners.",
    },
    {
      title: language === "fr" ? "Nettoyage après Sinistre" : "Post-Accident Cleanup",
      description:
        language === "fr"
          ? "Nettoyage et restauration après collision ou sinistre."
          : "Cleaning and restoration after collision or damage.",
    },
  ];



  const toggleDescription = (index: number) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="relative min-h-screen overflow-hidden text-white">
      {/* Carrousel d'images en fond */}
      {images.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out ${index === currentImageIndex ? "opacity-100 z-10" : "opacity-0 z-0"
            }`}
          style={{
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-black/50 z-10" />

      <div className="relative z-20 flex flex-col text-center h-full px-4 mb-15 mt-35">
        {/* Boutons d'appel à l'action avec margin-top pour éviter le Navbar */}
        <div className="mb-6 flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-6 flex-wrap">
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-full md:w-auto px-4 py-2 bg-yellow-500 text-black font-semibold rounded shadow hover:bg-yellow-600 transition duration-300"
          >
            {language === "fr" ? "Estimation Gratuite" : "Free Estimate"}
          </button>

          <EstimationModal
            language={language}
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}

          />

          <button
            onClick={() => setIsRdvModalOpen(true)}
            className="w-full md:w-auto px-4 py-2 bg-yellow-500 text-black font-semibold rounded shadow hover:bg-yellow-600 transition duration-300"
          >
            {language === "fr" ? "Prendre Rendez-vous" : "Book an Appointment"}
          </button>

          <RendezVousModal
            language={language}
            isOpen={isRdvModalOpen}
            onClose={() => setIsRdvModalOpen(false)}
          />


        </div>


        <h2 className="text-3xl font-extrabold text-yellow-500 mb-4 text-left md:pl-10">
          {language === "fr" ? "Nos services de carrosserie" : "Our Bodywork Services"}
        </h2>

        {/* Liste des services alignée à gauche */}
        <ul className="w-full max-w-3xl space-y-4 mt-4 text-left md:text-left md:pl-10">
          {services.map((service, index) => (
            <li
              key={index}
              className="cursor-pointer bg-gray-800 p-4 rounded shadow transition duration-300 hover:bg-gray-700"
              onClick={() => toggleDescription(index)}
            >
              <div className="flex justify-start items-center">
                <span className="mr-2">
                  {activeIndex === index ? (
                    <FaMinus className="text-yellow-500" />
                  ) : (
                    <FaPlus className="text-yellow-500" />
                  )}
                </span>
                <h2 className="text-xl font-medium text-yellow-500">
                  {service.title}
                </h2>
              </div>
              <div
                className={`mt-2 text-sm text-gray-300 ${activeIndex === index ? "block" : "hidden"
                  }`}
              >
                {service.description}
              </div>
            </li>
          ))}
        </ul>
      </div>

    </div>
  );
};

export default ServicesCarrosserie;
